<template>
  <div class="h-dialogContainer">
    <div class="h-borderBox" style="height:320px">
      <div class="h-dialog-borderBox-topIcon">{{$t('MCS.groupNum')}}  {{userNum}}
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
              <div>
                <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='delGroupMember'>
                  <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :pageSettings="pageSettings" :dataSource="data" height='169px' :allowReordering='true' :allowResizing='true' :rowSelected='lineClick' :rowDeselected='lineClick'>
          <e-columns>
            <e-column field='userNum' headerText='MC-ID' width='20%' textAlign='Center'></e-column>
            <e-column field='mcName' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userAlias")' width='20%' textAlign='Center'></e-column>
            <e-column field='userPriority' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userPriority")' width='20%' textAlign='Center'></e-column>
            <e-column field='userType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
            <e-column field='userPrivilege' clipMode='EllipsisWithTooltip' :valueAccessor='userPrivilegeFormatter' :headerText='$t("MCS.userPrivilege")' width='20%' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
        <!--<ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>-->
        <ejs-pager @click='getGridData()' :pageSize="pageSettings.pageSize" :pageCount="pageCount" :currentPage="page.pageNo" ref='pager'></ejs-pager>
      </div>
    </div>
    <br/>
    <div class="h-borderBox height-260">
      <div class="h-borderBox-content" style="overflow: hidden">
        <div class="h-dialog-borderBox-topIcon">
          <div class="h-toolbarBg dialog-icon-style">
            <ejs-toolbar class="dialog-icon-style">
              <div class="dialog-icon-style" >
                <div>
                  <button :title='$t("MCS.mod")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='modGroupMember'>
                    <span class="e-btn-icon icon hero-icon hero-icon-save e-icons"></span>
                  </button>
                </div>
              </div>
            </ejs-toolbar>
          </div>
        </div>
        <div class="h-borderBox-content" style="overflow: hidden">
          <div class="col-sm-6 h-col-inputBox">
            <span>MC-ID:</span>
            <ejs-textbox :cssClass='clsInput' v-model='textObj.userNum.val' :readonly='textObj.userNum.readonly'/>
          </div>
          <div class="col-sm-6 h-col-inputBox">
            <span>{{$t('MCS.userAlias')}}:</span>
            <ejs-textbox :cssClass='clsInput' v-model='textObj.userAlias.val' :readonly='textObj.userAlias.readonly'/>
          </div>
          <div class="col-sm-6 h-col-inputBox">
            <span>{{$t('MCS.userPriority')}}:</span>
            <ejs-dropdownlist :fields='fields' :dataSource='optionsUserPriority' v-model='textObj.userPriority.val' :enabled='!(textObj.userPriority.readonly)'/>
          </div>
          <div class="col-sm-6 h-col-inputBox">
            <span>{{$t('MCS.userPrivilege')}}:</span>
            <ejs-dropdownlist :fields='fields' :dataSource='optionsUserPrivilege' v-model='textObj.userPrivilege.val' :enabled='!(textObj.userPrivilege.readonly)'/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonJS from '../../common';

export default {
  name: 'QryGroupMemberDialog',
  mixins: [commonJS],
  props: [
    'neid',
    'vpnId'
  ],
  data() {
    return {
      textObj: {
        userNum: {
          val: '',
          readonly: true
        },
        userAlias: {
          val: '',
          readonly: true
        },
        userPriority: {
          val: '1',
          readonly: true
        },
        userPrivilege: {
          val: '0',
          readonly: true
        },
      },
      data: '',
      userNum: '',
      clsInput: 'h-subscriber-input',
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 0,
      },
      pageSettings: { pageSize: 15 },
      pageCount: 4,
      delFlag: false
    };
  },
  methods: {
    getGridData(userNum = this.userNum,firstFlag=false) {
      const $this = this;
      this.userNum = userNum;
      $this.page.pageNo = $this.$refs.pager.ej2Instances.currentPage;
      if(firstFlag){
        $this.page.pageNo = 1;
      }
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.qryGroupMember
        },
        vo: {
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          flag: 0,
          groupId: userNum,
          vpnId: 0,
        },
        page: {
          pageNo: $this.page.pageNo,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data;
        const resData = res.resultVal.result;
        $this.data = resData;
        // $this.page.totalCount = res.resultVal.totalCnt;
        $this.$refs.pager.ej2Instances.totalRecordsCount = res.resultVal.totalCnt;
      });
    },
    delGroupMember() {
      const $this = this;
      if ($this.$refs.grid.getSelectedRecords().length === 0) {
        $this.$toast('warning', $this.$t('Common.tips.noSelect'));
        return;
      }
      $this.$layer.confirm({
        msg: $this.$t('MCS.deleteConfirm'),
        btn1: {
          msg: this.$t('MCS.cancle'),
        },
        btn2: {
          msg: $this.$t('MCS.confirm'),
          func: () => {
            const vo = {
              enterpriseDomain: $this.enterpriseDomain,
              productType: $this.productType,
              groupId: $this.userNum,
              opCount: 1,
              groupMemberId: [$this.$refs.grid.getSelectedRecords()[0].groupMemberId],
              flag: 0
            };
            const params = {
              vo: vo,
              info: {
                msgid: $this.msg.delGroupMember,
                neid: $this.neid
              },
              log: {
                module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
                execFunName: 'subscriber.delroupMember',
                exectype: 1,
                execData: [{ groupid: vo.groupid, userNum: $this.$refs.grid.getSelectedRecords()[0].userNum }]
              }
            };
            this.$axios.post(this.requestCommon, params).then((response) => {
              $this.commonResp(response);
              this.getGridData(this.userNum,true);
              this.delFlag = true;
              this.textObj = {
                userNum: {
                  val: '',
                  readonly: true
                },
                userAlias: {
                  val: '',
                  readonly: true
                },
                userPriority: {
                  val: 1,
                  readonly: true
                },
                userPrivilege: {
                  val: 0,
                  readonly: true
                },
              };
            });
          }
        }
      });
    },
    modGroupMember() {
      const $this = this;
      if (this.$refs.grid.getSelectedRecords().length === 0) {
        console.log(this.textObj);
        this.textObj = {
          userNum: {
            val: '',
            readonly: true
          },
          userAlias: {
            val: '',
            readonly: true
          },
          userPriority: {
            val: '1',
            readonly: true
          },
          userPrivilege: {
            val: '0',
            readonly: true
          },
        };
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return;
      }
      const vo = this.$refs.grid.getSelectedRecords()[0];
      vo.userPrivilege = $this.textObj.userPrivilege.val;
      vo.userPriority = $this.textObj.userPriority.val;
      vo.enterpriseDomain = $this.enterpriseDomain;
      vo.productType = $this.productType;
      vo.opCount = 1;
      vo.userNum = [vo.userNum];
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.modGroupMember
        },
        vo: vo,
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.modGroupMember',
          exectype: 1,
          execData: [{ groupNum: vo.groupid, userNum: vo.userNum }]
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        $this.commonResp(response);
        $this.getGridData();
      });
    },
    lineClick() {
      if (this.$refs.grid.getSelectedRecords().length === 0) {
        this.textObj = {
          userNum: {
            val: '',
            readonly: true
          },
          userAlias: {
            val: '',
            readonly: true
          },
          userPriority: {
            val: '1',
            readonly: true
          },
          userPrivilege: {
            val: '0',
            readonly: true
          },
        };
      } else {
        const record = this.$refs.grid.getSelectedRecords()[0];
        if (this.delFlag === true) {
          this.delFlag = false;
          return;
        }
        console.log(record);
        this.textObj = {
          userNum: {
            val: record.userNum,
            readonly: true
          },
          userAlias: {
            val: record.mcName,
            readonly: true
          },
          userPriority: {
            val: record.userPriority,
            readonly: false
          },
          userPrivilege: {
            val: record.userPrivilege,
            readonly: parseInt(record.userType) === 7 ? false : true
          },
        };
      }
    }
  },

};
</script>

<style scoped>

</style>
